import { registerRootComponent } from 'expo';
import App from './App';

// Web entry — native uses index.native.js (React Native Firebase is not supported on web).
registerRootComponent(App);
